$(() => {
    $("[data-carousel]").each(function () {
        new ProductCarousel($(this))
    })
})

class ProductCarousel {
    constructor($element) {
        this.element = $element;
        this.run();
    }

    run() {
        this.carousel = this.element.owlCarousel({
            margin: 16,
            nav: false,
            responsive: {
                0: {
                    items: 2
                },
                576: {
                    items: 3
                },
                992: {
                    items: 4,
                    margin: 24,
                    nav: true,
                    navText: [
                        '<i class="icon icon-arrow-left"></i>',
                        '<i class="icon icon-arrow-right"></i>',
                    ],
                }
            }
        })
    }
}